export default "__VITE_ASSET__Czyrh0LX__"